"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultFairs = exports.getBlackFairs = exports.getMegaFairs = exports.isDefaultFair = exports.isBlackFair = exports.isMegaFair = void 0;
const types_1 = require("../services/fairs/types");
const isFairType = (fair, type) => fair.type === type;
const isMegaFair = (fair) => isFairType(fair, types_1.FairType.Mega);
exports.isMegaFair = isMegaFair;
const isBlackFair = (fair) => isFairType(fair, types_1.FairType.Black);
exports.isBlackFair = isBlackFair;
const isDefaultFair = (fair) => isFairType(fair, types_1.FairType.Default);
exports.isDefaultFair = isDefaultFair;
const findByMatchingProperties = (set, properties) => set.filter((entry) => Object.keys(properties).every((key) => entry[key] === properties[key]));
const getMegaFairs = (set) => findByMatchingProperties(set, { type: types_1.FairType.Mega });
exports.getMegaFairs = getMegaFairs;
const getBlackFairs = (set) => findByMatchingProperties(set, { type: types_1.FairType.Black });
exports.getBlackFairs = getBlackFairs;
const getDefaultFairs = (set) => findByMatchingProperties(set, { type: types_1.FairType.Default });
exports.getDefaultFairs = getDefaultFairs;
//# sourceMappingURL=index.js.map